/**
 * Skeleton per liste in caricamento.
 * Usato quando i dati non sono in cache (primo mount) per dare feedback visivo
 * più elegante rispetto allo spinner classico.
 */

export function SkeletonRows({ count = 3, color = "slate", label = "Caricamento dati in background..." }) {
  const colorMap = {
    slate: "bg-slate-100",
    orange: "bg-orange-100",
    red: "bg-red-100",
    amber: "bg-amber-100",
    blue: "bg-blue-100",
    violet: "bg-violet-100",
    emerald: "bg-emerald-100",
  };
  const bg = colorMap[color] || colorMap.slate;
  return (
    <div className="space-y-3" data-testid="skeleton-rows">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`flex items-center gap-3 p-3 rounded-lg animate-pulse ${bg}`}>
          <div className="w-10 h-10 rounded-full bg-white/60" />
          <div className="flex-1 space-y-2">
            <div className="h-3 bg-white/80 rounded w-3/4" />
            <div className="h-2.5 bg-white/60 rounded w-1/2" />
          </div>
          <div className="w-16 h-6 bg-white/60 rounded" />
        </div>
      ))}
      {label && <div className="text-center text-xs text-slate-500 italic pt-1">{label}</div>}
    </div>
  );
}

/**
 * Griglia di stat-card skeleton (per header pagine con KPI).
 */
export function SkeletonStatsGrid({ count = 4 }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-testid="skeleton-stats">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-xl p-6 shadow-sm border animate-pulse">
          <div className="h-3 bg-slate-100 rounded w-1/3 mb-3" />
          <div className="h-8 bg-slate-200 rounded w-1/2" />
        </div>
      ))}
    </div>
  );
}

/**
 * Skeleton tabellare per liste dati (usato in Ordini/Payments/Interviews).
 */
export function SkeletonTable({ rows = 6, cols = 4 }) {
  return (
    <div className="bg-white rounded-lg border overflow-hidden" data-testid="skeleton-table">
      <div className="bg-slate-50 border-b p-3 flex gap-4">
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className="h-3 bg-slate-200 rounded animate-pulse flex-1" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="border-b p-4 flex gap-4 items-center">
          {Array.from({ length: cols }).map((_, j) => (
            <div
              key={j}
              className={`h-3 bg-slate-100 rounded animate-pulse ${j === 0 ? "w-8 h-8 !rounded-full" : "flex-1"}`}
              style={{ animationDelay: `${(i * cols + j) * 50}ms` }}
            />
          ))}
        </div>
      ))}
      <div className="text-center text-xs text-slate-500 italic p-3">Caricamento dati in background...</div>
    </div>
  );
}
